var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D85111",
    d: "M14.215 6a3.35 3.35 0 0 0-1.645-.429H9.36A1.62 1.62 0 0 1 11 7.174V12h1.569a3.31 3.31 0 0 0 2.575-1.226a3.17 3.17 0 0 0-.93-4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.171 10.714A3.54 3.54 0 0 1 12.428 12h-1.286V7.174c0-.883-.81-1.603-1.714-1.603c-.908 0-1.714.72-1.714 1.603V18.43h5.747a3.7 3.7 0 0 0 .823-.086a4.04 4.04 0 0 0 3.287-3.93a4.15 4.15 0 0 0-2.4-3.699"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBico);
export default __webpack_public_path__ + "static/media/bico.35d97f9c2ff442d0505cd7fcd5c99b41.svg";
export { ForwardRef as ReactComponent };